import { useMutation } from "@tanstack/react-query";
import { updateBroadcast } from "../api/updateBroadcast";
import { BroadcastToUpdate } from "../types";

type Params = {
  broadcastId: string;
  broadcast: BroadcastToUpdate;
};

export const useUpdateBroadcastQuery = () => {
  return useMutation({
    mutationFn: async ({ broadcastId, broadcast }: Params) => {
      return await updateBroadcast(broadcastId, broadcast);
    },
    onError: (e) => console.error(e),
  });
};
